var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"bullshit__oops"},[_vm._v("OOPS!")]),_vm._v(" "),_c('div',{staticClass:"bullshit__headline"},[_vm._v("子应用加载错误")]),_vm._v(" "),_c('div',{staticClass:"bullshit__info"},[_vm._v("请检查主应用中singleSpa.js里的appInfos的路径是否错误")])])
}]

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/js/module/layout/_source/errorApp.vue